import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './topBanner.scss';

function TopBanner({ children, bannerImage, className, dataType }) {
    const wrapperClass = `top-banner-wrapper ${className || ''}`;
    const isDomain = dataType === 'domain';

    return (
        <div className={wrapperClass}>
            <Container>
                <Row>
                    <Col xxl={isDomain ? 6 : 5} xl={6} lg={6} md={12}>
                        <div className="banner-column-left">{children}</div>
                    </Col>
                    <Col xxl={isDomain ? 6 : 7} xl={6} lg={6} md={12}>
                        <div className="banner-column-right">{bannerImage}</div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

TopBanner.propTypes = {
    children: PropTypes.node.isRequired,
    bannerImage: PropTypes.object || PropTypes.string || PropTypes.node,
    className: PropTypes.string,
    dataType: PropTypes.string
};

TopBanner.defaultProps = {
    bannerImage: null,
    className: '',
    dataType: 'home'
};
export default TopBanner;
